import { INVENTORY_LOT_STATUS_TO_LABEL, INVENTORY_STATUS_TO_LABEL } from "./constants"

import type { InventoryByLotStatus, InventoryByPalletItemLot, InventoryStatus } from "@/graphql/codegen/graphql"

export const getInventoryStatusLabel = (status: InventoryStatus): string => INVENTORY_STATUS_TO_LABEL[status] ?? status

export const getInventoryLotStatusLabel = (status: InventoryByLotStatus): string =>
  INVENTORY_LOT_STATUS_TO_LABEL[status] ?? status

export const getInventoryLotKey = (lot: InventoryByPalletItemLot): string => `${lot.lotNumber}-${lot.batchNumber}`
